export default __webpack_public_path__ + "static/media/scb.d51f32f2.svg";